import React, { useRef } from 'react';
import SliderItem from './SliderItem';
import SliderContext from './SliderContext';
import useSlider from '../../../hooks/useSlide';
import Loading from '../common/Loading';

export default function Slider (props) {
  const ref = useRef(null);

  const typeClassName = props.type === 'event' ? 'thumb' : props.type; // poster, thumb, schedule

  let viewCount = 0;// 이벤트 페이지에서 빠져야하는 갯수 체크
  props.data.map((item, index) => {
    if (item.pc_view_yn === 'N') { // ---- 메인페이지 하단 이벤트 노출 부분에서  강제로 비활성화 기능있어서 추가
      viewCount = viewCount + 1;
    }
  });

  if (props.data) {
    const {
      moveSlide,
      sliderIndex,
      slideCount,
      sliderPages,
      slideProps,
      paginationIndicator,
      totalInViewport
    } = useSlider(ref, props.data.length - viewCount, props.data, props.type);

    let relateId;
    let relateTitle;
    let relateTitleViewYn;
    let relateType = props.relate_type;

    if (props.relate_id != null) {
      relateId = props.relate_id;
      relateTitle = props.relate_title;
      relateTitleViewYn = props.relate_title_view_yn;
      relateType = props.relate_type;
    }

    return (
      <SliderContext.Provider value={[]}>
        {props.children}
        {props.data.length > 0 && (
          <div className={`module_${typeClassName}_list_w`}>
            {sliderPages > 1 &&
              <button style={{ visibility: ((sliderIndex + 1) !== 1) ? 'visible' : 'hidden' }} className='slide_button_prev' aria-label='이전 콘텐츠 보기' onClick={() => moveSlide('left', true)} tabIndex={props.view !== false ? ((sliderIndex + 1) === 1 ? '-1' : '0') : '-1'}>
                <span className='sb_inner'>
                  <span className='sb_paging'><i className='sbp_active'>{sliderIndex + 1}</i>/<i className='sbp_all'>{slideCount}</i></span>
                  <span className='sb_icon'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 12.414 22.828' style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}><path className='a' d='M-11109.5-16189.5l-10,10,10,10' transform='translate(11120.5 16190.914)' /></svg>
                    <i className='hide'>이전 콘텐츠 보기</i>
                  </span>
                </span>
              </button>}
            <div className={`module_${typeClassName}_list_swipe`}>
              <ul className={`module_${typeClassName}_list_inner`} ref={ref} {...slideProps}>
                {props.data.map((item, index) => {
                  if (item.pc_view_yn !== 'N') { // ---- 메인페이지 하단 이벤트 노출 부분에서  강제로 비활성화 기능있어서 추가
                    return (
                      <SliderItem
                        key={index}
                        view={props.view !== false ? (index - 1 >= (sliderIndex * totalInViewport) && index - 1 < (sliderIndex * totalInViewport + totalInViewport)) : false}
                        slide_key={index}
                        data={item || []}
                        type={props.type}
                        imageQuality={props.imageQuality}
                        relateId={relateId}
                        relateTitle={relateTitle}
                        relateTitleViewYn={relateTitleViewYn}
                        relateType={relateType}
                        mainContentsType={props.mainContentsType}
                        bottom_type={props.bottom_type}
                        clickParams={props.clickParams}
                      />
                    );
                  }
                })}
              </ul>
              <ul className='slide_dots_w' style={{ zIndex: -1 }}>
                {sliderPages > 1 ? (paginationIndicator(sliderPages)) : ''}
              </ul>
            </div>

            {sliderPages > 1 &&
              <button style={{ visibility: ((sliderIndex + 1) !== slideCount) ? 'visible' : 'hidden' }} className='slide_button_next' aria-label='콘텐츠 더 보기' onClick={() => moveSlide('right', true)} tabIndex={props.view !== false ? ((sliderIndex + 1) === slideCount ? '-1' : '0') : '-1'}>
                <span className='sb_inner'>
                  <span className='sb_paging'><i className='sbp_active'>{sliderIndex + 1}</i>/<i className='sbp_all'>{slideCount}</i></span>
                  <span className='sb_icon'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 12.414 22.828' style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}><path className='a' d='M-11109.5-16189.5l-10,10,10,10' transform='translate(11120.5 16190.914)' /></svg>
                    <i className='hide'>콘텐츠 더 보기</i>
                  </span>
                </span>
              </button>}
          </div>
        )}
      </SliderContext.Provider>
    );
  } else {
    return (
      <div>
        <Loading />
        <p style={{ textAlign: 'center' }}>데이터를 찾을 수 없습니다...</p>
      </div>
    );
  }
}
